import React, { type JSX } from 'react';

import ActiveDatabaseName from '../../../../../../Features/Routing/ActiveDatabaseName';
import { RutinUrvalType } from '../../../../../../Types/UrvalTypes';
import { Query } from '@apollo/client/react/components';
import { ApolloError } from '@apollo/client';
import { KodplanConsumer } from '../../../../../KodplanManager/Context/KodplanContext';
import {
  RutinUrvalListQuery as IRutinUrvalListQueryData,
  RutinUrvalListQueryVariables as IRutinUrvalListQueryVariables,
} from './_QueryTypes/RutinUrvalListQuery';
import query from './RutinUrvalListQuery.gql';
import { ActiveRoutineContext } from '../../../../../../Features/Routing/ActiveRoutine/ActiveRoutineContext';

interface IChildProps {
  loading: boolean;
  error?: ApolloError | Error;
  rutinUrvalList?: RutinUrvalType[] | null;
  /** Variables used to get the result */
  variables?: IRutinUrvalListQueryVariables;
}

interface IProps {
  collectionName: string;
  groupID?: string;
  codeSystemID?: string;
  usageCode?: string;
  routineID?: number;
  kodplanUrval: boolean;
  showDBStandard?: boolean;
  children: (childProps: IChildProps) => JSX.Element;
}

class RutinUrvalListQuery extends React.Component<IProps> {
  render() {
    return (
      <ActiveDatabaseName>
        {(databaseName: string | null) => {
          if (databaseName == null) {
            return this.props.children({
              loading: false,
              error: new Error('Could not get database name'),
            });
          }

          return (
            <ActiveRoutineContext.Consumer>
              {activeRoutine => {
                if (!activeRoutine) {
                  return this.props.children({
                    loading: false,
                    error: new Error('Could not get active routine info'),
                  });
                }

                const rutinID =
                  this.props.routineID != null
                    ? this.props.routineID
                    : activeRoutine.rutinInfo.rutinID;

                return (
                  <KodplanConsumer>
                    {({ activeKodplan }) => {
                      const skip =
                        !activeKodplan ||
                        !databaseName ||
                        activeRoutine.activeRoutineQueryLoading;
                      const variables: IRutinUrvalListQueryVariables = {
                        dbname: databaseName,
                        collection: this.props.collectionName,
                        rutinID,
                        gruppID: this.props.groupID,
                        kontoplanID: activeKodplan ? activeKodplan.id : '',
                        usagecode: this.props.usageCode,
                        kontoplanUrval: this.props.kodplanUrval,
                        showDBStandard: this.props.showDBStandard,
                      };

                      return (
                        <Query<
                          IRutinUrvalListQueryData,
                          IRutinUrvalListQueryVariables
                        >
                          query={query}
                          variables={variables}
                          skip={skip}
                        >
                          {({ loading, error, data }) => {
                            if (skip) {
                              return null;
                            }
                            return this.props.children({
                              loading,
                              error,
                              rutinUrvalList: data && data.routineselections,
                              variables,
                            });
                          }}
                        </Query>
                      );
                    }}
                  </KodplanConsumer>
                );
              }}
            </ActiveRoutineContext.Consumer>
          );
        }}
      </ActiveDatabaseName>
    );
  }
}

export default RutinUrvalListQuery;
